import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import slugify from "slugify";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { axiosGet } from "../../../Apis/axiosMethods";

const OESimilarParts = ({ ART_ID, part }) => {
    const { apiB2BURL, apiHeaderJson } = useContext(ConfigContext);

    const [crosses, setCrosses] = useState([]);
    const [loadingCrosses, setLoadingCrosses] = useState(false);
    const [showAll, setShowAll] = useState(false);

    const locale = localStorage.getItem("lang");
    const dir = localStorage.getItem("dir");
    const { t } = useTranslation();

    const GetCrossOEParts = async () => {
        try {
            setLoadingCrosses(true);

            const part_number = part.ART_SEARCH_NUMBER;
            const sup_id = part.ART_SUP_ID;

            const { data } = await axiosGet(`/Parts/GetCrossOEParts`, {
                lang: locale,
                part_number: part_number,
                sup_id: sup_id,
            }
            );

            if (data?.success) {
                const uniqueCrosses = Array.from(
                    new Map(
                        (data.data || []).map((cross) => [
                            `${cross.ART_SUP_BRAND || ""}-${cross.ARL_SEARCH_NUMBER || ""}`
                                .trim()
                                .toLowerCase(),
                            cross,
                        ])
                    ).values()
                );

                setCrosses(uniqueCrosses);
            }
        } catch (error) {
            console.error("Error fetching cross OE parts:", error);
        } finally {
            setLoadingCrosses(false);
        }
    };

    useEffect(() => {
        GetCrossOEParts();
    }, [part.ART_SEARCH_NUMBER, part.ART_SUP_ID]);

    return (
        <div className="container">
            {crosses.length > 0 && (
                <div
                    className="pb-5 mt-5"
                    dir={dir}
                    style={{
                        textAlign: dir === "rtl" ? "right" : "left",
                    }}
                >
                    <h4>{t("oe_numbers")}</h4>

                    <div className="row">
                        {(showAll ? crosses : crosses.slice(0, 12)).map(
                            (cross, index) => {
                                const part_slug =
                                    slugify(
                                        `${cross.ART_PRODUCT_NAME || ""}`.toLowerCase()
                                    ) +
                                    "-" +
                                    slugify(
                                        `${cross.ARL_SEARCH_NUMBER || ""}`.toLowerCase()
                                    ) +
                                    cross.ART_SUP_ID;

                                return (
                                    <div
                                        className="col-md-3"
                                        key={`OENumber-${cross.ART_SUP_BRAND}-${cross.ARL_SEARCH_NUMBER}-${index}`}
                                    >
                                        <NavLink
                                            to={`/Spare-Parts/OEM/${part_slug}`}
                                        >
                                            {cross.ART_SUP_BRAND} -{" "}
                                            {cross.ART_ARTICLE_NR}
                                        </NavLink>
                                    </div>
                                );
                            }
                        )}
                    </div>

                    {crosses.length > 12 && (
                        <div
                            className="mt-2"
                            style={{ textAlign: "center" }}
                        >
                            {showAll === false ? (
                                <span
                                    className="btn-link"
                                    onClick={() => setShowAll(true)}
                                    style={{
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    {t("show_more")}
                                </span>
                            ) : (
                                <span
                                    className="btn-link"
                                    onClick={() => setShowAll(false)}
                                    style={{
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    {t("show_less")}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default OESimilarParts;